import { Badge, Col, Row, Table } from "react-bootstrap";
import { ECG12LeadSection } from "./ECG12LeadSection";


export interface VerificationState {
    time_verified: boolean;
    matches: VerificationMatch[];
}

export interface VerificationMatch {
    section: string;
    data: any;
}

export interface Evidence {
    source: string;
    details: string;
    date?: string;
    verification?: VerificationState;
}


// Render scan_multi match details
export const renderMatchDetails = (verification: VerificationState) => {
    if (!verification) {
        return <></>;
    }

    return verification.matches.map((match, idx) => (
        <div key={idx} className="mb-1 p-2 border rounded bg-light">
            {/* <Row>
                <Col>
                    <Badge bg={verification.time_verified ? "success" : "warning"} className="me-2">
                        {match.section}
                    </Badge>
                </Col>
            </Row> */}
            <Row>
                <Col>
                    <small>
                        {match.section === 'medications' && (
                            <>
                                <Row>
                                    <Col><strong>Medication:</strong> {match.data.med_name}</Col>
                                </Row>
                                <Row>
                                    <Col><strong>First Admin Time:</strong> {match.data.first_admin_time}</Col>
                                </Row>
                            </>
                        )}
                        {match.section === 'labs' && (
                            <><strong>Lab:</strong> {match.data.lab_name} = {match.data.component_value} {match.data.component_units}</>
                        )}
                        {match.section === 'imaging' && (
                            <>
                                <Row>
                                    <Col>
                                        <strong>Imaging:</strong> {match.data.study}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <strong>Impression:</strong> <pre>{match.data.impression}</pre>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <strong>Modality:</strong> {JSON.stringify(match.data.modality)}
                                    </Col>
                                </Row>
                                <hr />
                            </>
                        )}
                        {match.section === 'orders' && (
                            <><strong>Order:</strong> {match.data.name} ({match.data.type})</>
                        )}
                        {match.section === 'vitals' && (
                            <>
                                <strong>Vital Signs Recorded:</strong>
                                <Table size="sm">
                                    <thead>
                                        <tr>
                                            <th>Vital</th>
                                            <th>Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr><td>HR</td><td>{match.data.hr ?? "-"}</td></tr>
                                        <tr><td>RR</td><td>{match.data.rr ?? "-"}</td></tr>
                                        <tr><td>SpO2</td><td>{match.data.spo2 ?? "-"}</td></tr>
                                        <tr><td>HRV</td><td>{match.data.hrv ?? "-"}</td></tr>
                                        <tr><td>BP</td><td>{match.data.nbps ?? "-"}/{match.data.nbpd ?? "-"}</td></tr>
                                        <tr><td>Perf</td><td>{match.data.perf ?? "-"}</td></tr>
                                    </tbody>
                                </Table>
                            </>
                        )}
                        {match.section === 'visits' && (
                            <><strong>Visit:</strong> Arrival - {match.data.cc}</>
                        )}
                        {match.section === 'ecg_12L' && (
                            <>
                                <strong>12-Lead ECG:</strong>
                                <ECG12LeadSection ecg={match.data} />
                            </>
                        )}
                        {match.section === 'ecg_continuous' && (
                            <><strong>Continuous ECG:</strong> {match.data.segment_rhythm}</>
                        )}
                        {match.section === 'notes' && (
                            <>
                                <Row>
                                    <Col>
                                        <strong>Note:</strong> {match.data.note_type}
                                    </Col>
                                </Row>
                                {match.data.note_text && (
                                <Row>
                                    <Col>
                                        <pre>
                                            {match.data.note_text}
                                        </pre>
                                    </Col>
                                </Row>
                                )}
                            </>
                        )}
                    </small>
                </Col>
            </Row>
        </div>
    ));
};
